import React, { useState } from 'react'
import { IconButton, Icon, Message } from 'rsuite'
import CustomNote from './CustomNote'
import CustomNoteImage from './CustomNoteImage'

export default function CustomAlertMessageInfo(props) {
  const { contents, title } = props
  const [isShow, setIsShow] = useState(true)
  const type = 'info'

  return (
    <>
      {contents?.length > 0 && (
        <div>
          <IconButton
            color="orange"
            icon={<Icon appearance="ghost" icon="info" />}
            onClick={() => {
              setIsShow(!isShow)
            }}
          />
          <span
            style={{ color: 'orange', cursor: 'pointer' }}
            onClick={() => {
              setIsShow(!isShow)
            }}
          >
            {title || 'คำอธิบายการกรอกข้อมูล'}
          </span>
          {isShow && (
            <>
              {contents?.map((item, index) => {
                if (item.type == 'note') {
                  return <CustomNote key={'customNote-' + index} data={item} />
                } else if (item.type == 'image') {
                  return <CustomNoteImage key={'customNoteImage-' + index} data={item} />
                } else {
                  return (
                    <div key={index}>
                      {item && (
                        <>
                          {item.title && (
                            <p style={{ marginTop: 10, marginBottom: 5 }}>
                              <b>{item.title}</b>
                            </p>
                          )}

                          {item.details &&
                            item.details.map((dItem, dIndex) => {
                              return (
                                <Message
                                  key={`${index}-${dIndex}`}
                                  showIcon
                                  type={dItem.type || type}
                                  description={dItem}
                                  style={{ marginBottom: 10 }}
                                />
                              )
                            })}
                        </>
                      )}
                    </div>
                  )
                }
              })}
            </>
          )}
        </div>
      )}
    </>
  )
}
